module.exports = __webpack_public_path__ + "img/MiddleSide_Left.e491ef6a.jpg";